import React, { useState, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "../../Main/Record/PhoneInput/PhoneInput.js";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";

const FAQ_DATA = [
  {
    question: "Как я могу получить справку в налоговую для вычета?",
    answer: (
      <>
        <p>
          Добрый день! Порядок выдачи справок для предоставления налогового
          вычета размещён на официальном сайте учреждения:
        </p>

        <ul>
          <li>
            <a
              href="https://www.urniidvi.ru/files/patients/zayv_nalog_med.pdf"
              target="_blank"
              rel="noreferrer"
              className="question-answer-record__text question-answer-text"
            >
              Форма заявления
            </a>
          </li>
          <li>
            <a
              href="https://www.urniidvi.ru/files/patients/nalogvichet2025.pdf"
              target="_blank"
              rel="noreferrer"
              className="question-answer-record__text question-answer-text"
            >
              Порядок выдачи справок
            </a>
          </li>
          <li>
            <a
              href="https://www.urniidvi.ru/patients/pay"
              target="_blank"
              rel="noreferrer"
              className="question-answer-record__text question-answer-text"
            >
              Информация для пациентов о платных медицинских услугах
            </a>
          </li>
        </ul>
      </>
    ),
  },
  {
    question: "Как записаться на приём?",
    answer: (
      <p>
        Запись на приём осуществляется по телефону регистратуры +7 (343)
        218-95-86 или при личном обращении в учреждение.
      </p>
    ),
  },
  {
    question: "Какие документы необходимо иметь при себе?",
    answer: (
      <p>
        При обращении необходимо иметь паспорт, полис ОМС, направление (при
        наличии).
      </p>
    ),
  },
];

export default function QuestionAnswer() {
  const [activeIndex, setActiveIndex] = useState(null);

  const [formData, setFormData] = useState({
    fio: "",
    phone: "+7",
    email: "",
    question: "",
  });

  const [isAgree, setIsAgree] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [wasSubmitted, setWasSubmitted] = useState(false);
  const [message, setMessage] = useState("");

  const [showPopup, setShowPopup] = useState(false);
  const [popupStatus, setPopupStatus] = useState("idle");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const recaptchaRef = useRef(null);

  const API_URL =
    process.env.NODE_ENV === "production"
      ? "https://api.urniidvi.ru"
      : "http://localhost:5000";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const isFormValid = () => {
    const phoneDigits = formData.phone.replace(/\D/g, "");
    return (
      formData.fio.trim() &&
      phoneDigits.length >= 11 &&
      isValidEmail(formData.email) &&
      formData.question.trim() &&
      captchaValue &&
      isAgree
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setWasSubmitted(true);
    setMessage("");

    if (!isFormValid()) {
      return setMessage("Пожалуйста, заполните все поля корректно.");
    }

    setIsSubmitting(true);
    setShowPopup(true);
    setPopupStatus("sending");

    try {
      const res = await fetch(`${API_URL}/api/send-faq`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...formData,
          to_email: "urniidvi-online@mail.ru",
        }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Ошибка");

      setFormData({ fio: "", phone: "+7", email: "", question: "" });
      setWasSubmitted(false);
      recaptchaRef.current.reset();
      setCaptchaValue(null);
      setPopupStatus("success");
    } catch (err) {
      setMessage(err.message);
      setPopupStatus("error");
    }
  };

  return (
    <section className="contacts patients">
      <Breadcrumbs />
      <h1 className="contacts__title history__title">Вопрос–ответ</h1>

      {/* Форма */}
      <form
        onSubmit={handleSubmit}
        className="record__input-box question-answer__form"
      >
        <input
          className="record__input"
          type="text"
          name="fio"
          placeholder="ФИО"
          value={formData.fio}
          onChange={handleChange}
        />

        <PhoneInput
          className="record__input"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
        />

        <input
          className="record__input"
          type="email"
          name="email"
          placeholder="E-mail"
          value={formData.email}
          onChange={handleChange}
        />

        <textarea
          className="record__input"
          name="question"
          placeholder="Ваш вопрос"
          value={formData.question}
          onChange={handleChange}
        />

        <ReCAPTCHA
          sitekey="6LdGG7srAAAAAGK6wMRUdW1xdkSsS6areWMsJhsW"
          ref={recaptchaRef}
          onChange={setCaptchaValue}
        />

        <label className="record__text question-answer-record__text">
          <input
            type="checkbox"
            checked={isAgree}
            onChange={() => setIsAgree(!isAgree)}
          />{" "}
          Я даю согласие на обработку персональных данных (
          <a
            href="/about/privacy"
            target="_blank"
            rel="noreferrer"
            className="question-answer-text"
          >
            политика
          </a>
          )
        </label>

        {message && <p className="record__message">{message}</p>}

        <button
          type="submit"
          disabled={!isFormValid() || isSubmitting}
          className="record__button question-answer-record__button"
        >
          {isSubmitting ? "Отправка..." : "Отправить вопрос"}
        </button>
      </form>

      {/* FAQ */}
      <div className="faq">
        {FAQ_DATA.map((item, index) => (
          <div
            key={index}
            className={`faq__item ${activeIndex === index ? "active" : ""}`}
          >
            <button
              type="button"
              className="faq__question"
              onClick={() =>
                setActiveIndex(activeIndex === index ? null : index)
              }
            >
              {item.question}
              <span className="faq__icon">
                {activeIndex === index ? "−" : "+"}
              </span>
            </button>

            {activeIndex === index && (
              <div className="faq__answer">
                <p>{item.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
